import React from 'react';
import { angleLimits, dataHooks } from './AngleInput.constants';
import { classes, st } from './AngleInput.st.css';
import { AngleInputProps } from './AngleInput.types';
import { useAngleInput } from './hooks/useAngleInput';
import { useDefaultProps } from '../WixDesignSystemDefaultPropsProvider';

const AngleInput = (props: AngleInputProps) => {
  const {
    onChange,
    onPointerDown,
    onPointerUp,
    onFocus,
    onBlur,
    dataHook,
    value,
    disabled = false,
    step = 1,
  } = useDefaultProps('AngleInput', props);
  const {
    rootRef,
    handlePointerDown,
    handlePointerUp,
    handlePointerMove,
    handleInputChange,
    handleKeyboardEvent,
    handleFocus,
    handleBlur,
  } = useAngleInput({
    onChange,
    onPointerDown,
    onPointerUp,
    onFocus,
    onBlur,
    step,
  });

  return (
    <div
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      className={st(classes.root, { disabled })}
      data-hook={dataHook}
      aria-disabled={disabled}
      ref={rootRef}
    >
      <div className={classes.track} data-hook={dataHooks.track}>
        <div
          className={st(classes.knobWrapper)}
          data-hook={dataHooks.knobWrapper}
          style={{
            transform: `rotate(${value}deg)`,
          }}
        >
          <div className={st(classes.knob)} data-hook={dataHooks.knob}>
            <input
              type="range"
              value={value}
              className={classes.visuallyHiddenInput}
              onChange={handleInputChange}
              onKeyDown={handleKeyboardEvent}
              onFocus={handleFocus}
              step={step}
              onBlur={handleBlur}
              min={angleLimits.min}
              max={angleLimits.max}
              disabled={disabled}
              data-hook={dataHooks.input}
            />
          </div>
        </div>

        <div
          className={classes.arm}
          style={{
            transform: `rotate(${value}deg)`,
          }}
        />
      </div>
    </div>
  );
};

AngleInput.displayName = 'AngleInput';

export default AngleInput;
